import * as React from 'react';
import gql from 'graphql-tag';
import { ChildProps, graphql, compose } from 'react-apollo';

const CacheCrawlerStatsQuery = gql`
  query {
    getCurrentState
  }
`;

const RegeneratePageCacheMutation = gql`
  mutation {
    regeneratePageCache
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

class CacheCrawlerQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
  render() {
    const { stats , regeneratePageCache/*, updateCategory, deleteCategory */ }: any = this.props;
    return this.props.children({
      cacheCrawler: stats,
      regeneratePageCache,
      /* createCategory,
      deleteCategory */
    });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(CacheCrawlerStatsQuery, {
    name: 'stats',
    options: props => ({
      fetchPolicy: 'network-only'
    })
  }),
  graphql<IInputProps, IResponse>(RegeneratePageCacheMutation, {
    name: 'regeneratePageCache'
  }),
  /* graphql<IInputProps, IResponse>(CreateCategoryMutation, {
    name: 'createCategory'
  }),
  graphql<IInputProps, IResponse>(DeleteCategoryMutation, {
    name: 'deleteCategory'
  }) */
)(CacheCrawlerQuery);



// WEBPACK FOOTER //
// ./src/components/Query/CacheCrawler/CacheCrawler.ts